// import { Typography } from '@mui/material';

const FooterContats = () => {
    return (
        <div>
            <p style={{fontSize: "15px", margin:"0px"}}>
                whatsapp: 
                (77)9 9902-4465
                (77)9 9968-1775 
            </p>
            <div>
                <p style={{fontSize: "15px", margin:"0px"}}> 
                Instagram:
                @Agro.mind
                </p>
            </div>
            <div>
                <p style={{fontSize: "15px", margin:"0px"}}>
                Localização:
                Rua Itacaré n°456 Santa Cruz - Luis Eduardo Magalhães
                </p>
            </div>
            <div>
                <p style={{fontSize: "15px", margin:"0px"}}> 
                Email:
                Agromind.adm@gmail.com
                 </p>
            </div>
        </div>
    )
}

 
export default FooterContats
